<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createHttpConfig } from "./fs";
  import { makeFileSystemHttp, testHttpConnection } from "./fs-http";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createHttpConfig());
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.url.trim() != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("testing http connection");
    try {
      let url = config.url.trim();
      if (!/^https?:\/\//i.test(url)) {
        url = "https://" + url;
      }
      if (!url.endsWith("/")) {
        url += "/";
      }
      let host = new URL(url).host;
      config.url = url;
      await testHttpConnection(config);
      if (config.name.trim() == "") {
        config.name = host;
      } else {
        config.name = config.name.trim();
      }
      let fs = makeFileSystemHttp(config);
      telegramNotify(`New HTTP connection for ${host}`);
      captureEvent("http-login", {});
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect HTTP site">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-http-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-http-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-http-url">URL of a directory listing:</label>
      <input
        type="text"
        id="input-http-url"
        autocomplete="off"
        placeholder="https://example.com/pub/"
        class="outline-hidden border px-2 py-1 w-72"
        bind:value={config.url}
      />

      <div class="mt-4 text-sm text-gray-500 w-72">
        A web server that lists its directories as pages of links. Read only.
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 text-red-500 font-medium break-all w-72">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect HTTP site</button>
    </div>
  {/snippet}
</DialogBase>
